<dgx-search-field-wrapper (click)="focusSkillSearch()" class="guts-m-h-2-half">
  <input
    #skillSearchInput
    id="skillSearch"
    type="text"
    role="combobox"
    [(ngModel)]="skillSearchTerm"
    name="skillSearch"
    [placeholder]="i18n.Onboarding_SearchSkills_SearchForSkills"
    [attr.aria-label]="i18n.Onboarding_SearchSkills_SearchForSkills"
    [attr.aria-expanded]="isPopoverOpen"
    aria-controls="search-popover-skill"
    aria-autocomplete="list"
    aria-haspopup="listbox"
    (input)="onInputChange($event)"
    autocomplete="off"
    [ngClass]="{ 'input-spinner': loadingResults }"
    data-dgat="skill-search-72c"
  />
  <!-- popover element for suggested skills -->
  <dgx-popover
    #popoverComponent
    role="listbox"
    id="search-popover-skill"
    [(isOpen)]="shouldShowTagDropdown"
    (isOpenChange)="onIsPopoverOpenChange($event, popoverComponent)"
    [popoverTrigger]="skillSearchInputRef"
    [focusFirstItem]="false"
    [placementAdjustLeftRem]="2"
    placement="bottom-left"
    class="__typeahead-popup"
  >
    <!--Search input auto suggest menu contents. role=menu and role=menuitem are both a11y attributes AND custom directives that enable keyboard navigation-->
    <div class="overflow-scroll-gradient__scroller __search-menu" role="menu">
      <ng-container
        *ngFor="let suggestion of suggestions"
        class=""
        data-dgat="skill-search-fee"
      >
        <button
          class="l_flexbar guts-p-v-1 guts-p-l-0 guts-p-r-1 listbox--option"
          role="menuitem"
          (click)="addSkill(suggestion)"
          data-dgat="skill-search-766"
        >
          <dgx-skill-typeahead-item
            [item]="suggestion"
            [searchTerm]="skillSearchTerm"
          ></dgx-skill-typeahead-item>
        </button>
      </ng-container>
    </div>
  </dgx-popover>
  <!-- custom skill menu-->
  <dgx-popover
    #popoverComponentCustomTag
    role="listbox"
    id="search-popover-skill"
    (isOpenChange)="onIsPopoverOpenChange($event, popoverComponentCustomTag)"
    [(isOpen)]="shouldShowCustomTag"
    [popoverTrigger]="skillSearchInputRef"
    [focusFirstItem]="false"
    placement="bottom-left"
    class="__typeahead-popup custom"
  >
    <div role="menu">
      <ul class="typeahead-list js-suggestion-list">
        <li class="typeahead-item guts-p-b-half">
          <p
            class="guts-p-l-1 guts-p-v-1 color-ebony-a61 par--small font-medium"
            [innerText]="i18n.TargetResourcesForm_NoResults"
          ></p>
          <button
            role="menuitem"
            class="guts-p-v-0 guts-p-l-0 guts-p-r-1 listbox--option"
            (click)="addSkill(customItem)"
            data-dgat="searchTags-d22"
          >
            <div class="l_flexbar guts-p-v-1 guts-p-h-0">
              <div class="icon-spot bg-color-ebony-a08 center-item guts-m-h-1">
                <df-icon icon="tag" class="color-ebony-a61"></df-icon>
              </div>
              <div class="l_flex-grow">
                <h3
                  class="par par--small font-bold"
                  [innerText]="skillSearchTerm"
                ></h3>
              </div>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </dgx-popover>
</dgx-search-field-wrapper>
